<div class="toggle-container">
  @if (label) {
    <span class="label-text">{{ label }}</span>
  }
  <label class="toggle-wrapper">
    <input
      type="checkbox"
      class="toggle-input"
      [(ngModel)]="checked"
      (change)="onToggle()"
    />
    <span class="toggle-slider"></span>
  </label>
</div>
